import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { about } from "../content";
import { Reveal } from "./Reveal";

export const About = () => {
  const visualRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: visualRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="sobre" className="scroll-mt-20 bg-[#F7F7F5] py-24 md:py-36" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-7">
            <Reveal>
              <span className="rounded-full bg-black px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-white">
                {about.label}
              </span>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1] tracking-tighter text-[#1A1A1A] sm:text-5xl lg:text-6xl">
                {about.headline}
              </h2>
            </Reveal>
          </div>
          <div className="flex flex-col justify-end md:col-span-5">
            <Reveal delay={0.14}>
              <p className="text-base leading-relaxed text-black/70 md:text-lg">{about.body}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 border-l-2 border-[#00E5FF] pl-5 text-sm leading-relaxed text-black/55 md:text-base">
                {about.secondary}
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-16 md:mt-24">
          <div ref={visualRef} className="relative aspect-[16/9] overflow-hidden rounded-[2rem] border border-black/10 md:aspect-[21/9]" data-testid="about-visual">
            <motion.img
              src="/assets/about-visual.jpg"
              alt="Perfil de Lucas Rocha envolvido por tiras de filme com cenas, robôs e interfaces de edição"
              style={{ y }}
              className="absolute inset-0 h-full w-full scale-[1.15] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent" />
            <span className="absolute bottom-5 left-5 rounded-full border border-white/25 bg-black/45 px-3 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-white/85 backdrop-blur">
              {about.visualCaption}
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
